export default [
    {
        path: '/static/marketing/sms-detail',
        name: 'marketing-sms-detail',
        component: () => import('views/modules/member/marketing/sms-detail/index'),
        meta: {
            title: '短信详情',
        },
    },
    {
        path: '/static/marketing/email-detail',
        name: 'marketing-email-detail',
        component: () => import('views/modules/member/marketing/email-detail/index'),
        meta: {
            title: '邮件详情',
        },
    },
];
